import { getClient } from "services";

const userService = () => getClient("userService");

export async function fetchMyInfo() {
  return await userService().fetchMyInfo();
}
